import { Box, EmptyState } from '@dixa/lib-shared-habla';
import useCollectionTreeFetch from 'hooks/useCollectionTreeFetch';
import { useSetAtom } from 'jotai';
import { useTypedParams } from 'lib-knowledge-utils/hooks/useTypedParams';
import { ampli } from 'lib-shared-tracking';
import { collectionIdAtom } from 'models/collectionStore';
import { useEffect } from 'react';

import CollectionLayout from './components/layout/layout';

function CollectionEditPage(): JSX.Element {
  // TODO: change this to a url tracking atom!
  const { collectionId } = useTypedParams(['collectionId']);
  const setCollectionId = useSetAtom(collectionIdAtom);
  useEffect(() => {
    setCollectionId(collectionId);
  }, [collectionId, setCollectionId]);

  const { data, error, loading } = useCollectionTreeFetch({ collectionId });

  useEffect(() => {
    ampli.knowledgeCollectionViewed({ collectionId, source: 'management' });
  }, [collectionId]);

  if (error || (!loading && (!data?.collection || !data?.collection?.title))) {
    return (
      <Box padding="400">
        <EmptyState
          title="Something went wrong"
          description={
            error?.message || 'Please refresh the page and try again'
          }
        />
      </Box>
    );
  }

  return <CollectionLayout loading={loading} data={data} />;
}

export default CollectionEditPage;
